<template>
    <div class="col-lg-12" style="padding: 20px">
      <div class="main-card mb-3 card" style="margin-left: 10px">
        <div class="card-body">
          <h5 class="card-title">학습점수내역</h5>
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 4px 10px 2px 10px;
            "
          >
            학습점수관리 → 학습점수내역
          </div>
          
          <query-grid :config="config" ref="qg">
            <template #items="props">
              <tr
                v-for="record in props.records"
                v-bind:key="record.id"
                :class="{ 'table-danger': record.is_deleted }"
              >
             
                <td scope="row" style="text-align: center">                  
                  {{ record.id }}
                </td>
                <td style="text-align: center">{{ record.username }}</td>
                <td style="text-align: center"> <Student :student="record" /></td>
                <td
                  style="text-align: center"
                  v-if="
                    this.$root.guiPerm != 'CLASS' &&
                    this.$root.guiPerm != 'ENTERPRISE'
                  "
                >                
                  <Business v-if="record.t2" :biz="record.t2" />
                </td>  
                <td scope="row" style="text-align: center">                  
                  <template v-if="record.chrPType == 'A'">ALPHA</template
                    ><template v-else-if="record.chrPType == 'C'">CARAT</template
                      ><template v-else>FAME
                   </template>
                </td>
                <td style="text-align: center;width:10%">
                  <template v-if="record.intPoint == 'N/A'">사용할 수 없음</template
                  ><template v-else>{{
                    parseInt(record.intPoint).toLocaleString()
                  }}</template>
                </td>
                <td scope="row" style="text-align: center">                  
                  <template v-if="record.chrGubun == 'P'">적립</template
                  ><template v-else>차감
                   </template>
                  
                </td>
                <td scope="row" style="text-align: center">                  
                  {{ record.strHistory }}
                </td>
                <td scope="row" style="text-align: center">                  
                  {{ record.datRegDate }}
                </td>
               
                <td>                                 
                <button
                  class="btn btn-danger btn-sm"
                  @click="deletePoint(record)"
                >
                  삭제
                </button>        
                <PointModify :PointModify="record" :ref="'pointM'+record.intNo" />        
              </td>
              </tr>
            </template>
          </query-grid>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  
  import Business from "../components/Business";
  import Student from "../components/detail_pages/Student";
  import QueryGrid from "../components/QueryGrid";
  import PointModify from "../components/detail_pages/PointModify";  
  import axios from "axios";
  export default {
    name: "Home",
    components: {
      Business,
      Student,
      QueryGrid,
      PointModify
    },
    mounted() {
      
  
      if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
        this.config.columns.splice(1, 1);
      }
  
      this.$refs.qg.search();
    },
    methods: {
          deletePoint(record) {
            console.log("record.intNo:"+record.intNo);
          if (!confirm("정말로 삭제할까요?")) return;
          axios.delete("/students/pointDel/" + record.intNo ).then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message: "삭제할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              $.notify(
                {
                  // options
                  message: "삭제되었습니다.",
                },
                {
                  // settings
                  type: "success",
                  z_index: 9999,
                }
              );
              this.$refs.qg.search();
            }
          });
        },
    },
    data() {
      return {
        config: {
          name: "회원점수현황",
          req_endpoint: "/students/pointList",
          default_limit: 20,
         
          search_fields: [
            {
              id: "businesses",
              name: "소속선택",
              type: "business", // business, date, datetime,
            },
            {
                id: "type_filter",
                name: "종류",
                type: "switch",
                filter_type: {
                "A": "ALPHA",
                "C": "CARAT",
                "F": "FAME"
            }
            },
            {
                id: "gubun_filter",
                name: "유형",
                type: "switch",
                filter_type: {
                    "P": "적립",
                    "M": "차감"
                }
            },     
            {
              id: "search",
              name: "키워드검색",
              type: "text",
              placeholder:
                "아이디/이름/회원번호/튜터명/학원/클래스/담당교사/레벨",
            },
          ],
          columns: [
           
            
            {
              id: "intNo",
              sortable: true,
              name: "회원번호",
              excel_print: (v) => {
                return v.id;
              },
            },
            {
              id: "username",
              sortable: true,
              name: "아이디",
              excel_print: (v) => {
                return v.username;
              },
            },
            {
              id: "hanname",
              sortable: true,
              name: "이름",
              excel_print: (v) => {
                return v.name;
              },
            },
            {
              id: "biz",
              sortable: true,
              name: "학원/캠퍼스",
              excel_print: (v) => {
                return v.t2.name;
              },
            },
            {
              id: "type",
              sortable: true,
              name: "종류",
              excel_print: (v) => {
                if (v.chrPType =="A"){
                    return 'ALPHA';
                }else if (v.chrPType =="C"){
                    return 'CARAT';
                }else{
                  return 'FAME';
                } 
                
              },
            },
            
            {
              id: "point",
              sortable: true,
              name: "점수",
              excel_print: (v) => {
                return v.intPoint || "";
              },
            },
            {
              id: "gubun",
              sortable: true,
              name: "유형",
              excel_print: (v) => {
                 if (v.chrGubun =="P"){
                    return '적립';
                }else{
                  return '차감';
                }
              },
            },
            {
              id: "history",
              sortable: false,
              name: "내용",
              excel_print: (v) => {
                return v.strHistory || "";
              },
            },
            {
              id: "regdate",
              sortable: true,
              name: "등록일",
              excel_print: (v) => {
                return v.datRegDate;
              },
            },
            {
            id: "action",
            name: "관리",
            },
          ],
          disable_init_search: true,
        },
      };
    },
  };
  </script>
  